"use client"
import { useState, useEffect } from "react"
import { useNavigate, Link, useLocation } from "react-router-dom"
import "./NavBar.css"

export default function LeftNavigation({ activeItem: propActiveItem }) {
    const [collapsed, setCollapsed] = useState(false)
    const [mobileOpen, setMobileOpen] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()
    const [activeItem, setActiveItem] = useState(propActiveItem)

    useEffect(() => {
        setActiveItem(propActiveItem)
    }, [propActiveItem])

    const toggleCollapse = () => {
        setCollapsed(!collapsed)
    }

    const toggleMobileMenu = () => {
        setMobileOpen(!mobileOpen)
    }

    const handleBackToHome = () => {
        navigate("/")
    }

    const handleNavigation = (path) => {
        navigate(path)
        setMobileOpen(false)
    }

    return (
        <>
            {/* Mobile menu toggle button */}
            <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                <span className="menu-icon"></span>
                Menu
            </button>

            <nav className={`left-navigation ${collapsed ? "collapsed" : ""} ${mobileOpen ? "mobile-open" : ""}`}>
                <div className="nav-header">
                    <h2>Bảng Điều Khiển</h2>
                    <button className="collapse-button" onClick={toggleCollapse}>
                        {collapsed ? "»" : "«"}
                    </button>
                </div>

                <ul className="nav-menu">
                    <li className="back-to-home">
                        <button onClick={handleBackToHome} className="nav-link">
                            <span className="nav-icon">🏠</span>
                            <span className="nav-text">Về Trang Chủ</span>
                        </button>
                    </li>
                    <li className={activeItem === "product" ? "active" : ""}>
                        <button onClick={() => handleNavigation("/manager/products")} className="nav-link">
                            <span className="nav-icon product-icon">📦</span>
                            <span className="nav-text">Sản Phẩm</span>
                        </button>
                    </li>
                    <li className={activeItem === "product-category" ? "active" : ""}>
                        <button onClick={() => handleNavigation("/manager/product-category")} className="nav-link">
                            <span className="nav-icon category-icon">🗂️</span>
                            <span className="nav-text">Danh Mục Sản Phẩm</span>
                        </button>
                    </li>
                    <li className={activeItem === "service" ? "active" : ""}>
                        <button onClick={() => handleNavigation("/manager/services")} className="nav-link">
                            <span className="nav-icon service-icon">🔧</span>
                            <span className="nav-text">Dịch Vụ</span>
                        </button>
                    </li>
                    <li className={activeItem === "service-category" ? "active" : ""}>
                        <button onClick={() => handleNavigation("/manager/service-category")} className="nav-link">
                            <span className="nav-icon service-category-icon">📋</span>
                            <span className="nav-text">Danh Mục Dịch Vụ</span>
                        </button>
                    </li>
                    <li className={activeItem === "news" ? "active" : ""}>
                        <button onClick={() => handleNavigation("/manager/news")} className="nav-link">
                            <span className="nav-icon news-icon">📰</span>
                            <span className="nav-text">Tin Tức</span>
                        </button>
                    </li>
                    <li className={activeItem === "news-category" ? "active" : ""}>
                        <button onClick={() => handleNavigation("/manager/news-category")} className="nav-link">
                            <span className="nav-icon news-category-icon">📑</span>
                            <span className="nav-text">Danh Mục Tin Tức</span>
                        </button>
                    </li>
                    <li className={activeItem === "banner" ? "active" : ""}>
                        <button onClick={() => handleNavigation("/manager/banner")} className="nav-link">
                            <span className="nav-icon banner-icon">🖼️</span>
                            <span className="nav-text">Banner</span>
                        </button>
                    </li>
                    <li className={activeItem === "architects" ? "active" : ""}>
                        <button onClick={() => handleNavigation("/manager/architects")} className="nav-link">
                            <span className="nav-icon architects-icon">🏛️</span>
                            <span className="nav-text">Kiến Trúc Sư</span>
                        </button>
                    </li>
                    <li className={activeItem === "user" ? "active" : ""}>
                        <button onClick={() => handleNavigation("/manager/users")} className="nav-link">
                            <span className="nav-icon user-icon">👤</span>
                            <span className="nav-text">Người Dùng</span>
                        </button>
                    </li>
                    <li className={activeItem === "support" ? "active" : ""}>
                        <button onClick={() => handleNavigation("/manager/support")} className="nav-link">
                            <span className="nav-icon support-icon">🔔</span>
                            <span className="nav-text">Hỗ Trợ</span>
                        </button>
                    </li>
                </ul>

                <div className="nav-footer">
                    <div className="user-info">
                        <div className="user-avatar">A</div>
                        {!collapsed && (
                            <div className="user-details">
                                <div className="user-name">Quản Trị Viên</div>
                                <div className="user-role">Administrator</div>
                            </div>
                        )}
                    </div>
                </div>
            </nav>
        </>
    )
}
